import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import actionConstants from 'redux/actions/actionConstant';

/**
 * This hook handles API calls with automatic loader state management.
 * Usage:
 * const apiHandler = useApiHandler();
 * const response = await apiHandler(apiCallFunction, arg1, arg2);
 */

const useApiHandler = ({ showLoader = true } = {}) => {
    const dispatch = useDispatch();

    const apiHandler = useCallback(
        async (apiCall, ...args) => {
            try {
                if (showLoader) {
                    dispatch({ type: actionConstants.START_LOADER });
                }
                const response = await apiCall(...args);
                return response;
            } catch (error) {
                return error;
            } finally {
                if (showLoader) {
                    dispatch({ type: actionConstants.STOP_LOADER });
                }
            }
        },
        [dispatch, showLoader]
    );

    return apiHandler;
};

export default useApiHandler;
